/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * imgBaseUrl: 图片所在域名地址
 *
 */
let PROCESS_ENV = process.env.VUE_APP_ENV
let BASE_URL = process.env.VUE_APP_API_BASE
let BASE_HREF = process.env.VUE_APP_HREF_BASE
let IMG_BASE_URL = 'http://youp-read.leqilucky.com'

export {
  PROCESS_ENV,
  BASE_URL,
  BASE_HREF,
  IMG_BASE_URL
}
